import { render, staticRenderFns } from "./ScrollPane.vue?vue&type=template&id=00b84fe2&scoped=true&"
import script from "./ScrollPane.vue?vue&type=script&lang=ts&"
export * from "./ScrollPane.vue?vue&type=script&lang=ts&"
import style0 from "./ScrollPane.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ScrollPane.vue?vue&type=style&index=1&id=00b84fe2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b84fe2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\opusb-web-myactio\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00b84fe2')) {
      api.createRecord('00b84fe2', component.options)
    } else {
      api.reload('00b84fe2', component.options)
    }
    module.hot.accept("./ScrollPane.vue?vue&type=template&id=00b84fe2&scoped=true&", function () {
      api.rerender('00b84fe2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/layout/components/TagsView/ScrollPane.vue"
export default component.exports